// import * as icons from "@material-ui/icons";
import * as React from 'react';
import { connect } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import Admin from '../Admin/Admin';
import Login from '../Login/Login';

class App extends React.Component<any, any> {
  public render() {
    return (
      <>
        {this.props.auth.user ? (
          <BrowserRouter>
            <Admin />
          </BrowserRouter>
        ) : (
          <Login />
        )}
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.tsx